export default class AlGuestlistFormFieldCustomFieldModalController {

    constructor($uibModalInstance, $scope, $injector, currentDefinition, alreadyExists, fieldAvailabilities, Alert) {
        this.modalInstance = $uibModalInstance;
        this.scope = $scope;
        this.injector = $injector;
        this.translate = this.injector.get('$translate');
        this.filter = this.injector.get('$filter');
        this.definition = currentDefinition;
        this.alreadyExists = !!alreadyExists;
        this.fieldAvailabilities = fieldAvailabilities;
        this.alert = Alert;

        this.disableGlobalCheckbox = false;
        this.isGlobalField = false;

        this._initGlobalFieldInformation();
    }

    _initGlobalFieldInformation() {
        if (this.fieldAvailabilities.contact) {
            if (!this.fieldAvailabilities.rsvp) {
                this.disableGlobalCheckbox = true;
                this.isGlobalField = true;
            } else {
                this.disableGlobalCheckbox = false;
                this.isGlobalField = false;
            }
        } else {
            this.disableGlobalCheckbox = true;
            this.isGlobalField = false;
        }
    }

    dismiss() {
        this.modalInstance.dismiss();
    }



    save(form, action, data) {
        const translatedValue = (path) => {
            return this.translate.instant(`guestlists.editor.components.ask-to-delete-field.${path}`);
        };

        if (action === 'delete') {
            // custom message for rsvp and client
            let message = translatedValue('content');
            if(this.definition.global) {
                message = translatedValue('content2');
            }
            this.alert.animatedAlert(
                translatedValue('title'),
                message,
                'attention',
                {
                    confirmButtonText: translatedValue('confirm'),
                    cancelButtonText: translatedValue('cancel')
                }).then(() => {
                // delete the field on confirm
                this.resolveAction(form, action, data)
            }, () => ({}))
        } else {
            // if action is to add a new field, add it directly
            this.resolveAction(form, action, data)
        }
    }

    resolveAction(form, action, data) {
        if (form && !form.$valid) {
            return;
        }

        data = data || {};

        if (!this.alreadyExists) {
            data.group = this.isGlobalField ? 'contact' : 'rsvp';
        }

        this.modalInstance.close({
            action,
            data: data || null
        });
    }
}

AlGuestlistFormFieldCustomFieldModalController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'currentDefinition',
    'alreadyExists',
    'fieldAvailabilities',
    'Alert'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-editor/general/form-field-selector/controllers/custom-field-modal.js